export class NumberUtils {
  public static numberToFinancialDisplay = (input: number): string => {
    return input.toString().replace(/(?=\B(\d{3})+$)/g, ",");
  };

  public static percentageToDisplay = (input: number): string => {
    return `${(Math.round(input * 10000) / 100).toFixed(1)}%`;
  };

  public static numberToFinancialDisplayForIndonesia = (
    input: number
  ): string => {
    return input.toString().replace(/(?=\B(\d{3})+$)/g, ",");
  };

  public static getCurrency = (currencyCode: string) => {
    const lowerCaseCode = currencyCode.toLowerCase();
    if (lowerCaseCode === "idr") return "Rp";
    if (lowerCaseCode === "sgd") return "S$";
    if (lowerCaseCode === "myr") return "RM";
    if (lowerCaseCode === "thb") return "Bht";
    if (lowerCaseCode === "php") return "PHP";
    if (lowerCaseCode === "vnd") return "VND";
    if (lowerCaseCode === "usd") return "$";
    if (lowerCaseCode === "aud") return "A$";
    return "Rp";
  };
}
